module.exports = __webpack_public_path__ + "youtrack-logo.png";